import { useSelector } from 'react-redux';
import _ from 'underscore';
import { selectCurrentUser } from 'ducks/currentUser/selectors';

const useIsAuthorized = () => {
	const currentUser = useSelector(selectCurrentUser);
	const isAuthorized = !_.isEmpty(currentUser);

	return { isAuthorized, currentUser };
};

export default useIsAuthorized;
